import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'catalogos/clases/';

/**
 * GET Clases
 * param {object} params
 * @returns {Promise<object>}
 */
export const getClases = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Clase
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClase = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Clase
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClase = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clase
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClase = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clase
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClase = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
